/**
 * Dates as both apps print them: **UTC, always.**
 *
 * A shared space spans agencies, and the operator console is read across all of
 * them. A date that shifted with the viewer's clock would have two sides
 * describing one upload, one deletion, or one audit event as having happened on
 * different days — so the day is the UTC day, and where the time of day is shown
 * the zone is named rather than left to be misread as local.
 *
 * The locale is the caller's: it is a presentation choice that changes with
 * language, and each surface's copy file is the seam where that will be dealt
 * with. The format itself is one fact, which is why it lives here rather than in
 * the eleven components that used to carry their own copy of it.
 */

const DAY: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
};

/** `Feb 10, 2026` */
export function formatUtcDate(iso: string, locale: string): string {
  return new Date(iso).toLocaleDateString(locale, DAY);
}

/** `Feb 10, 2026, 04:05 PM UTC` — for a screen read across local times. */
export function formatUtcDateTime(iso: string, locale: string): string {
  const formatted = new Date(iso).toLocaleString(locale, {
    ...DAY,
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${formatted} UTC`;
}
